// extracted by mini-css-extract-plugin
export var previewContainer = "_sd-0";